module.exports = __webpack_public_path__ + "img/jingDian-3.697625e2.jpg";